import { render } from "./oncology_notes.vue?vue&type=template&id=319cf0b4&scoped=true"
import script from "./oncology_notes.vue?vue&type=script&lang=js"
export * from "./oncology_notes.vue?vue&type=script&lang=js"

import "./oncology_notes.vue?vue&type=style&index=0&id=319cf0b4&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-319cf0b4"]])

export default __exports__